import React from 'react';

interface SidebarFieldProps {
  label: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const SidebarField: React.FC<SidebarFieldProps> = ({ label, icon, children }) => (
  <div className="task-details-modal__sidebar-field">
    <label>
      {icon}
      {label}
    </label>
    {children}
  </div>
);
